module.exports = require("sha.js");